<template>
  <v-card class="work-and-study-rights mt-3 elevation-4">
    <v-toolbar card prominent class="transparent">
      <v-toolbar-title class="title">
        Clubs and Societies
      </v-toolbar-title>
      <v-spacer />
      <can I="edit" a="Profile">
        <v-tooltip left>
          <v-dialog slot="activator" v-model="creating" max-width="600">
            <v-btn small fab slot="activator" color="secondary">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-card>
              <v-card-title class="title">Add a club or society</v-card-title>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Name"
                    v-model="affiliation.name"
                    required :rules="rules.name"
                  />
                  <v-text-field
                    label="Position"
                    v-model="affiliation.position"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn flat block color="grey" @click="creating = false">Cancel</v-btn>
                <v-btn block color="primary" @click="add">Add</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <span>Add a club or society</span>
        </v-tooltip>
      </can>
    </v-toolbar>

    <v-card-text>
      <v-chip
        v-for="affiliation in profile.affiliations"
        :key="affiliation.id"
        :close="$can('edit', 'Profile')"
        label
        @input="remove(affiliation.id)"
      >
        <strong v-html="affiliation.name" />
        <span v-if="affiliation.position">&nbsp;({{ affiliation.position }}) </span>
      </v-chip>
    </v-card-text>
  </v-card>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'

// Data

// Vue Components
export default {
  data() {
    return {
      creating: false,
      affiliation: {
        profile: { id: this.$route.params.id },
        name: '',
        position: '',
      },
      rules: {
        name: [v => !!v || 'must be specified'],
      },
    }
  },
  computed: mapGetters({ profile: 'admin/profiles/find' }),
  methods: {
    add() {
      this.$store.dispatch('admin/affiliations/create', this.affiliation).then(
        // Success
        response => {
          this.$store.commit('snackbar', {
            text: 'Club or Society was added successfully',
            type: 'success',
          })
          this.$store.dispatch('admin/profiles/fetch', this.profile.id)
          this.creating = false
          this.affiliation.name = ''
          this.affiliation.position = ''
        },
        // Failure
        errors => {
          this.$store.commit('snackbar', {
            text: 'Club or Society could not be added',
            type: 'error',
          })
        }
      )
    },
    remove(id) {
      this.$store.dispatch('admin/affiliations/destroy', id).then(
        // Success
        response => {
          this.$store.commit('snackbar', {
            text: 'Club or Society was removed successfully',
            type: 'success',
          })
          this.$store.dispatch('admin/profiles/fetch', this.profile.id)
        },
        // Failure
        errors => {
          this.$store.commit('snackbar', {
            text: 'Club or Society could not be removed',
            type: 'error',
          })
        }
      )
    },
  },
}
</script>
